import React from 'react';
import { Outlet } from 'react-router-dom';

const Content = () => {
  return (
    <div className='container p-2'>
      <h2 className='m-2'>Content</h2>
      <Outlet />
    </div>
  );
};

export default Content;
